export function loginNotice(search = "") {
  const params = new URLSearchParams(search);
  if (!params.has("authError")) return null;
  const code = params.get("authError");
  const denied = ["DEVELOPER_ACCESS_REQUIRED", "DEVELOPER_ENGINE_ACCESS_REQUIRED", "DEVELOPER_CONTEXT_REVOKED", "DEVELOPER_SESSION_REVOKED"].includes(code);
  return {
    message: denied
      ? "هذا الحساب أو السياق لا يحمل صلاحية المطور الحالية. استخدم حساب المطور المعتمد."
      : code === "PASSWORD_CHANGE_REQUIRED"
        ? "غيّر كلمة المرور المؤقتة في Workspace أولًا ثم أعد الدخول."
        : "تعذر إكمال الدخول الموحد، وقد تكون التذكرة منتهية أو صادرة من نسخة أخرى. سجّل مباشرة بجوجل أو باسم المستخدم أدناه.",
    requestId: /^[a-zA-Z0-9-]{1,100}$/.test(params.get("ref") || "") ? params.get("ref") : "",
  };
}
